module.exports = __webpack_public_path__ + "static/media/brain.2d5c4114.svg";